import { UNIT_SYSTEM } from '../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../utils/constants';

const columns = (renderCell, renderActions, renderValueCell, drillStringDetailsUnit, currentUnit) => [
  {
    field: 'rowNumber',
    headerName: 'Row #',
    headerAlign: 'center',
    align: 'center',
    renderCell,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 210,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH + 160,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'od',
    headerName: `OD (${drillStringDetailsUnit?.od?.label})`,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(drillStringDetailsUnit?.od?.decimals));
    },
  },
  {
    field: 'id',
    headerName: `ID (${drillStringDetailsUnit?.id?.label})`,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(drillStringDetailsUnit?.id?.decimals));
    },
  },
  {
    field: 'len',
    headerName: `LEN (${drillStringDetailsUnit?.len?.label})`,
    renderEditCell: renderValueCell,
    editable: true,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 120,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 120,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(drillStringDetailsUnit?.len?.decimals));
    },
  },
  {
    field: 'cum_len',
    headerName: `CUM LEN (${drillStringDetailsUnit?.len?.label})`,
    renderEditCell: renderValueCell,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return parseFloat(value.toFixed(drillStringDetailsUnit?.len?.decimals));
    },
  },
  {
    field: 'tj_od',
    headerName: `TJ OD (${drillStringDetailsUnit?.tj_od?.label})`,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(drillStringDetailsUnit?.tj_od?.decimals));
    },
  },
  {
    field: 'tj_id',
    headerName: `TJ ID (${drillStringDetailsUnit?.tj_id?.label})`,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(drillStringDetailsUnit?.tj_id?.decimals));
    },
  },
  {
    field: 'tj_len%',
    headerName: 'TJ LEN (%)',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 100,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 100,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    headerAlign: 'center',
    align: 'center',
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderCell: (params) => renderActions({ row: params.row, index: params.api.getRowIndexRelativeToVisibleRows(params.id) }),
  },
];
export default columns;
